import React from 'react';

import { Link, Text } from '@change/ds-core-ui/next';

import { useDecisionMakerResponse } from './hooks/useDecisionMakerResponse';

export const DecisionMakerResponse: React.FC<{ response: string | undefined }> = ({ response }) => {
	const {
		data: { isResponseLong, responseText, readMoreLink },
		actions: { handleLinkClick },
	} = useDecisionMakerResponse(response);

	return (
		<div>
			<Text variant="body" className="font-serif mb-4 block italic">
				&ldquo;{responseText}&rdquo;
			</Text>

			{isResponseLong && (
				<Link
					href={readMoreLink}
					size="small"
					className="block"
					data-qa="read-dm-response"
					variant="secondary"
					onClick={handleLinkClick}
				>
					Read full response
				</Link>
			)}
		</div>
	);
};
